module.exports = __webpack_public_path__ + "static/media/5th_banner.edaffff4.png";